<template>
  <div>
    <ReactWrapper :component="DevicesPage" :props="props" />
  </div>
</template>

<script>
  import { DevicesPage } from '../../../../../frontendV2/dist/reactComponents';
  import ReactWrapper from '@/components/blocks/reactComponents/ReactWrapper';

  export default {
    name: 'DevicesPage',

    components: {
      ReactWrapper,
    },

    data: () => ({
      DevicesPage,
    }),

    computed: {
      props() {
        return {};
      },
    },
  };
</script>
